
export enum ChartSpecificTypesEnum {
    CARD_LIST = 'CARD_LIST',
    WORD_CLOUD = 'WORD_CLOUD',
    MULTI_STACKED_BAR = 'MULTI_STACKED_BAR',
    MULTI_STACKED_COLUMN = 'MULTI_STACKED_COLUMN',
    BAR = 'BAR',
    COLUMN = 'COLUMN',
    MULTI_LINE = 'MULTI_LINE',
    LINE = 'LINE',
    FILLED_LINE = 'FILLED_LINE',
    RIVER = 'RIVER',
    VALUES_LIST = 'VALUES_LIST',
    MAP = 'MAP',
    PIE = 'PIE',
    HEAT = 'HEAT',
    LIST = 'LIST'
}

